import React, { useState } from "react";
import { useDiaryData } from "../../hooks/useDiaryData";
import { useDispatch, useSelector } from "react-redux";
import { getDataFresh, getDiaryData } from "../../state/selectors";

import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Pagination,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import NewDiaryEntry from "./NewDiaryEntry";
import useWeekInput from "../../hooks/useWeekInput";
import {
  formatDate,
  getLastDayOfWeek,
  getFirstDayOfWeek,
  readableDate
} from "../../utils";
import axios from "axios";
import {createSetDataFreshAction, createSetDiaryDataAction} from "../../actions/dataActions";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import DiaryRow from "./DiaryRow";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import PaginationWrapper from "../Utils/PaginationWrapper";

function DiaryView(props) {
  const dispatch = useDispatch();
  const [rangeType, setRangeType] = useState('all');

  const [date, dateInput, overrideDate] = useWeekInput({
    label: "Date Selection",
    initialValue: getFirstDayOfWeek(new Date()),
    weekly: rangeType === 'weekly'
  });

  const [completed, setCompleted] = useState(false);

  const [page, setPage] = useState(1);

  const dataFresh = useSelector(getDataFresh);

  const startDate = new Date(date);

  const params = {
    page, completed
  };

  if (rangeType !== 'all') {
      params.start_date = formatDate(rangeType === 'weekly' ? getFirstDayOfWeek(startDate) : startDate)
      params.end_date = formatDate(rangeType === 'weekly' ? getLastDayOfWeek(startDate) : startDate)
  }

  const complete = useDiaryData(
    params,
    dataFresh,
  );

  const onEntryUpdate = (index, newEntry) => {
    let newResults =  [...data.results];
    let newState = { ...data, results: newResults };
    newState.results[index] = newEntry;
    dispatch(createSetDiaryDataAction(newState));
  };

  const handleDelete = id => {
    const endpoint = "/api/diaryentry/" + id;
    const conf = { method: "delete", url: endpoint };
    axios(conf).then(() => dispatch(createSetDataFreshAction(dataFresh + 1)));
  };

  const updateRangeType = rangeType => {
    setPage(1);
    setRangeType(rangeType);
  };

  const handleCompleted = entry => {
    let newEntry = {...entry}
    newEntry.completed = true;
    const endpoint = "/api/diaryentry/" + newEntry.id;
    const conf = { method: "put", url: endpoint, data: newEntry };
    axios(conf).then(() => dispatch(createSetDataFreshAction(dataFresh + 1)));
  };

  const data = useSelector(getDiaryData);

  if (!complete){
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    )
  }

  document.title = "Diary";

  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <NewDiaryEntry />
      <Box>
        <Title>View Options</Title>
        <Columns isMultiline>
          <Column>
            <Field className="has-addons">
              <Control>
                <label className="label">View</label>
                <Button
                  color={rangeType === 'all' ? "primary" : ""}
                  onClick={() => updateRangeType('all')}
                >
                  All
                </Button>
                <Button
                  color={rangeType === 'weekly' ? "primary" : ""}
                  onClick={() => {
                    updateRangeType('weekly');
                    overrideDate(formatDate(new Date()));
                  }}
                >
                  Weekly
                </Button>
                <Button
                  color={rangeType === 'daily' ? "primary" : ""}
                  onClick={() => {
                      overrideDate(formatDate(new Date())); //Set date to today
                      updateRangeType('daily');
                  }}
                >
                  Daily
                </Button>
              </Control>
            </Field>
          </Column>
          {dateInput}
          <Column>
            <Field>
              <label className="label">Show Completed</label>
              <Control>
                <Checkbox
                  checked={completed}
                  type="checkbox"
                  name="completed"
                  onChange={() => setCompleted(!completed)}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Title>Diary</Title>
        <Table isFullwidth>
          <thead>
            <tr>
              <th>Start</th>
              <th>Time</th>
              <th>Task For</th>
              <th>Comments</th>
              <th>End</th>
              {completed &&
                <th>Completed</th>
              }
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((entry, index) =>
              <DiaryRow
                entry={entry}
                index={index}
                showCompleted={completed}
                endpoint={props.endpoint}
                handleDelete={handleDelete}
                handleCompleted={handleCompleted}
                onEntryUpdate={onEntryUpdate}
              />
            )}


          </tbody>
        </Table>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        >
        </PaginationWrapper>
      </Box>
    </div>
  );
}

export default DiaryView;
